import { UfFieldValue } from '../questionInputRegistry';

/** Renders an ADDRESS field value as a single display line, e.g.
 * "1600 Amphitheatre Pkwy, Mountain View, CA 94043, US". */
export const formatAddress = (value: UfFieldValue | undefined): string => {
  if (!value) return '';

  const lines = (value.address_lines ?? []).filter(Boolean);
  const localityLine = [value.locality, value.administrative_area]
    .filter(Boolean)
    .join(', ');
  const localityAndPostalCode = [localityLine, value.postal_code]
    .filter(Boolean)
    .join(' ');

  return [...lines, localityAndPostalCode, value.country]
    .filter(Boolean)
    .join(', ');
};
